import { CALL_ACTIVITY } from "../../constant/ActionType";

export default function ActivityCallRedc(
    state = {
        activityCall: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case CALL_ACTIVITY:
            return {
                ...state,
                activityCall: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
